export function dataLocalISO(data: Date): string {
  return `${data.getFullYear().toString().padStart(4, '0')}-${(data.getMonth() + 1).toString().padStart(2, '0')}-${data.getDate().toString().padStart(2, '0')}`;
}

export function ultimos30Dias(hoje = new Date()): { inicio: string; fim: string } {
  const inicio = new Date(hoje);
  inicio.setDate(inicio.getDate() - 29);
  return { inicio: dataLocalISO(inicio), fim: dataLocalISO(hoje) };
}

export function erroPeriodo(inicio: string, fim: string): string {
  if (!inicio || !fim) return 'Informe a data inicial e a data final.';
  const valida = (valor: string) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(valor) || valor < '0001-01-01' || valor > '9999-12-30') return false;
    const data = new Date(valor + 'T12:00:00');
    return !isNaN(data.getTime()) && dataLocalISO(data) === valor;
  };
  if (!valida(inicio) || !valida(fim)) return 'Informe datas válidas.';
  return inicio > fim ? 'A data inicial não pode ser posterior à data final.' : '';
}
